import { m } from 'framer-motion';

import Badge from '@mui/material/Badge';
import Drawer from '@mui/material/Drawer';
import SvgIcon from '@mui/material/SvgIcon';
import IconButton from '@mui/material/IconButton';

import { useBoolean } from 'src/hooks/use-boolean';

import { varHover } from 'src/components/animate';

import { FeedbacksContent } from './feedbacks-content';

// ----------------------------------------------------------------------

export function FeedbacksDrawer({ sx, ...other }) {
  const drawer = useBoolean();

  return (
    <>
      <IconButton
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        onClick={drawer.onTrue}
        sx={sx}
        {...other}
      >
        <Badge badgeContent={0} color="info">
          <SvgIcon>
            {/* https://icon-sets.iconify.design/solar/chat-round-dots-bold-duotone/ */}
            <path
              fill="currentColor"
              d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12c0 1.821.487 3.53 1.338 5.002L2.5 21.5l4.498-.838A9.955 9.955 0 0 0 12 22"
              opacity="0.5"
            />
            <path
              fill="currentColor"
              d="M7.25 12a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75m4 0a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75m4 0a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H16a.75.75 0 0 1-.75-.75"
            />
          </SvgIcon>
        </Badge>
      </IconButton>

      <Drawer
        open={drawer.value}
        onClose={drawer.onFalse}
        anchor="right"
        slotProps={{ backdrop: { invisible: true } }}
        PaperProps={{ sx: { width: 1, maxWidth: 420 } }}
      >
        <FeedbacksContent />
      </Drawer>
    </>
  );
}

